export const PRODUCTS = [
  {
    id: "turmeric",
    name: "Turmeric Powder",
    botanical: "Curcuma longa",
    origin: "Erode Region, Tamil Nadu",
    label: "Golden Root",
    tagline: "Carefully sourced, cleanly processed, sealed vivid.",
    image:
      "https://images.pexels.com/photos/4198656/pexels-photo-4198656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    notes: ["Earthy", "Warm", "Citrus Peel"],
    curcumin: "High Colour",
    description:
      "Sourced from trusted suppliers in an established turmeric-growing region, then processed and packed with care for cleanliness and colour. Sealed in food-grade barrier packaging so its warm, earthy aroma reaches you intact.",
  },
  {
    id: "coriander",
    name: "Coriander Powder",
    botanical: "Coriandrum sativum",
    origin: "Kota Region, Rajasthan",
    label: "Green Gold",
    tagline: "Carefully selected, cleanly ground, freshness-sealed.",
    image:
      "https://images.unsplash.com/photo-1770123366817-743776f66d6a?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    notes: ["Citrusy", "Nutty", "Warm"],
    curcumin: "Bright Aroma",
    description:
      "Sourced from trusted suppliers in an established coriander-growing region, then ground and packed with attention to aroma and consistency. Barrier packaging and proper sealing protect its fresh, citrusy warmth from air and moisture.",
  },
  {
    id: "chilli",
    name: "Chilli Powder",
    botanical: "Capsicum annuum",
    origin: "Guntur Region, Andhra Pradesh",
    label: "Red Fire",
    tagline: "Carefully sourced, quality-processed, deeply crimson.",
    image:
      "https://images.pexels.com/photos/33440713/pexels-photo-33440713.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    notes: ["Smoky", "Fruity", "Slow Burn"],
    curcumin: "Medium Heat",
    description:
      "Sourced from an established chilli-growing region and processed with attention to cleanliness, colour and flavour. Sealed in food-grade packaging so its living crimson colour and warm, rounded heat stay true from our store to yours.",
  },
];

export const BRAND = {
  name: "The Good Spoon",
  email: "goodspoon.query@gmail.com",
  phone: "7907631376",
  whatsapp: "+917907631376",
  city: "City of Spices, God's Own Country",
  heroImage:
    "https://images.pexels.com/photos/4198431/pexels-photo-4198431.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  storyImage:
    "https://images.unsplash.com/photo-1549859455-746ef4fae03b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
